module.exports = __webpack_public_path__ + "static/media/orange.29605c36.png";